import TableCell from "@mui/material/TableCell";
import { NacidTableImage } from "@duosoftbg/nacid-components";
import * as React from "react";
import { buildFetchFileUrl } from "../../../../axios/api/services";

const NationalUniversityLogoTableCell = ({ separatedPath }) => {
  return (
    <TableCell>
      <NacidTableImage
        maxWidth={30}
        maxHeight={30}
        src={buildFetchFileUrl(separatedPath.relativePath, separatedPath.fileId, null)}
      />
    </TableCell>
  );
};

export default NationalUniversityLogoTableCell;
